import * as React from 'react'
import { createGlobalStyle, css } from 'styled-components'
import { Reset } from 'styled-reset'

export const ResetCss = () => {
  return (
    <>
      <Reset/>
      <GlobalStyle />
    </>
  )
}


export const fontCompress = css`
  transform: scale(0.8,1);
  width: calc(100%/0.8);
  transform-origin: top left;
  letter-spacing: .05em;
  text-align: justify;
`
export const expandCompressedFont = css`
  transform: none;
  width: auto;
  transform-origin: 50% 50% 0;
  letter-spacing: normal;
  text-align: start;
`

const GlobalStyle = createGlobalStyle`
  html{
    opacity: 0;
  }
  html.wf-active{
    opacity: 1;
  }

  body{
    font-family: yu-gothic-pr6n, sans-serif;
    font-weight: 400;
    font-style: normal;
    -webkit-text-size-adjust: 100%;
  }

  body{
    *{
      font-feature-settings: "palt" 1;
    }
  }

  p{
    font-size: 16px;
    line-height: 30px;
    ${ fontCompress }
  }
  a{
    text-decoration: none;
  }
`


export default null